'use strict';

function ctrl($scope, Global, timeFormat, $http, fetchStream, socketIo, settings, usSpinnerService) {
    let model = this;
    $scope.global = Global;
    model.settings = settings;

    model.tableIdentifiers = { key: false, id: false };

    // Save active toggle
    model.toggleActive = function (data) {
        $http({
            method: 'POST',
            url: api+'/api/ioc_notifications/ioc_feeds/active',
            data: {
                feed : data.feed,
                active : data.active,
            }
        }).success(function () {
        })
    }

    socketIo('/api/ioc_notifications/ioc_feeds').then(function (socket) {
        /////////////
        /// TABLE ///
        /////////////

        // register data object
        $scope.main.registerVisual({
            // OPTIONAL setting to set all searches to searchdim (good for tables, but inefficient for other viz)
            // allSearchDimensionOverride: true,
            refresh: false, // TODO: if a number is placed here, it will overwrite the current 1min default
            searchable: true, // optional search param.. no if undefined
            get: {
                call: 'tablecount',
                socket: socket
            },
            grouping: ['feed'],
            sort: { direction: "-", col: "last_run" }, // "-"=desc, "+"=asc
            title: "Custom IOCs",
            hideToggleBytes: true,
            columns: [
                { title: 'Feed', select: 'feed', dView: true },
                { title: 'IOC Count', select: 'ioc_count', dView: true },
                { title: 'Class', select: 'class', dView: true },
                { title: 'Last Run', select: 'last_run', dView: true },
                {
                    title: 'Active',
                    select: 'active',
                    dView: true,
                    link: {
                        url: '/api/ioc_notifications/ioc_feeds/toggleActive',
                    },
                },
            ],
            searchCategories: {
                'feed': 'Feed',
                'class': 'Class',
                'ioc_count': 'IOC Count'
            },
            dimension: function (cfObj) { return cfObj.dimension(function (d) { return d.feed; })},
            group: function (dimension) { // groups are optional and should default to a reduce if undefined
                return dimension.group().reduce(
                    function (p, v) {
                        p.feed = v.feed;
                        if (v.hasOwnProperty("ioc_count")) {
                            p.ioc_count += Number(v.ioc_count);
                        }
                        if (v.hasOwnProperty("last_run")) {
                            p.last_run = v.last_run;
                        }
                        if (v.hasOwnProperty("active")) {
                            p.active = v.active;
                        }
                        if (v.hasOwnProperty("class")) {
                            p.class = v.class;
                        }
                        p.visible = true;
                        return p;
                    },
                    function (p, v) {
                        p.feed = v.feed;
                        if (v.hasOwnProperty("ioc_count")) {
                            p.ioc_count -= Number(v.ioc_count);
                        }
                        if (v.hasOwnProperty("last_run")) {
                            p.last_run = v.last_run;
                        }
                        if (v.hasOwnProperty("active")) {
                            p.active = v.active;
                        }
                        if (v.hasOwnProperty("class")) {
                            p.class = v.class;
                        }
                        p.visible = true;
                        return p;
                    },
                    function () {
                        return {
                            feed: "",
                            ioc_count: 0,
                            last_run: "",
                            active: 1
                        };
                    }
                );
            },
        })
        // fetch the data when the object is registered
        .then(function (result) {
            model.tableIdentifiers = {
                id: result.id,
                key: result.key
            }
            // initalize table with column information so it can compile the directive
            $scope.$broadcast('table-build', model.tableIdentifiers);

            let time = angular.copy($scope.main.getTime());
            model.loadStart = time.end
            model.loadEnd = time.end
            // set dimension & group
            $scope.main.dataObjects[model.tableIdentifiers.key].dimension = $scope.main.dataObjects[model.tableIdentifiers.key].settings.dimension($scope.main.dataObjects[model.tableIdentifiers.key].cf);
            $scope.main.dataObjects[model.tableIdentifiers.key].group = $scope.main.dataObjects[model.tableIdentifiers.key].settings.group($scope.main.dataObjects[model.tableIdentifiers.key].dimension);
            // return new fetchStream(result.settings.get.call, result.settings.get.socket);
            return new fetchStream(result.settings.get.call, result.settings.get.socket);
        }).then(function (result) {
            model.complete = true;
            // stop the table spinner as soon as the resolve comes in
            usSpinnerService.stop(model.tableIdentifiers.id);
        },
        function (err) {
        },
        function (result) {
            // add rows
            $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
            if (!$scope.main.dataObjects[model.tableIdentifiers.key].launched) {
                $scope.main.dataObjects[model.tableIdentifiers.key].launched = true;
                // dont start the spinner if the table loads faster than building group dim
                if (!model.complete) {
                    // start table spinner right before init, but after build
                    usSpinnerService.spin(model.tableIdentifiers.id);
                }
                // initalize rows
                $scope.$broadcast('init', model.tableIdentifiers);

                new fetchStream("table", $scope.main.dataObjects[model.tableIdentifiers.key].settings.get.socket).then(function (result) {
                }, function (err) {
                }, function (result) {
                    $scope.main.dataObjects[model.tableIdentifiers.key].cf.add(result.rows);
                })

                if (result.min) {
                    model.loadStart = result.min;
                }
            } else {
                if (result.min) {
                    model.loadStart = result.min;
                }
                $scope.$broadcast('updatedData', model.tableIdentifiers.id);
            }
        })
        $scope.$on('$destroy', function () {
            socket.disconnect();
        });
    })
};

ctrl.$inject = ['$scope', 'Global', 'timeFormat', '$http', 'fetchStream', 'socketIo', 'settings', 'usSpinnerService'];
module.exports = ctrl;



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/ioc_notifications/ioc_feeds.js
 **/